import cookies from "js-cookie";

import { login } from "@constants/navlinks";
import { ACCESS_TOKEN } from "@constants/common";

import type { AxiosError } from "axios";

export const statusError = (error?: AxiosError): void => {
  const status = error?.response?.status;

  switch (status) {
    case 400: {
      break;
    }
    case 401:
      cookies.remove(ACCESS_TOKEN);

      window.location.href = login;
      break;
    case 404:
      break;
    case 500:
      break;
    case undefined:
      break;
    default:
      break;
  }
};
